<template>
    <div class="content-wrapper">
        <PageHeader screenName="Cadastrar novo" :linkItems="linkItems"/>

         <ConfirmModal
            itemIdentifier="ponto de atendimento"
            :modalShow="modal.showModal"
            :typeModal="modal.typeModal"
            @confirmed="cancelRegister"
            @canceled="closeModalConfirm"
        />

        <SucessoModal
            :modalShow="modalSuccess.showModal"
            :typeModal="modalSuccess.typeModal"
            :caseModal="modalSuccess.caseModal"
            @confirmed="redirectToList"
        />

        <TimedAlert variant="success" message="Ponto de atendimento salvo com sucesso!" :show="savedAlert" />

        <main class="card p-2">
            <section class="form">
                <validation-observer ref="pontoAtendimentoRules">
                    <b-form>
                        <b-row>
                            <b-col lg="4" sm="12" class="pr-lg-0">
                                <b-form-group label="Nome do Ponto de Atendimento*" label-for="name">
                                    <validation-provider
                                        #default="{ errors }"
                                        name="name"
                                        rules="required"
                                    >
                                        <b-form-input
                                            :state="errors.length > 0 || form.errors.name ? false:null"
                                            id="name"
                                            autocomplete="off"
                                            v-model="form.name"
                                            placeholder="Ex: Farmácia SESI Trindade"
                                        />
                                        <small v-if="errors[0]" class="text-danger">
                                            Este campo é de preenchimento obrigatório.
                                        </small>
                                        <small v-if="form.errors.name" class="text-danger">
                                            {{ form.errors.name }}
                                        </small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                            <b-col lg="4" sm="12" class="pr-lg-0">
                                <validation-provider
                                    #default="{ errors }"
                                    name="Tipo"
                                    rules="required"
                                >
                                    <b-form-group
                                        label="Tipo*"
                                        label-for="type"
                                        :state="errors.length > 0 || form.errors.type ? false:null">
                                        <v-select
                                            id="type"
                                            :reduce="(option => option.id_tipo_ponto_atendimento)"
                                            v-model="form.type"
                                            :options="servicePointType"
                                            label="descricao"
                                            placeholder="Selecione o tipo"
                                        >
                                            <span slot="no-options">Nenhuma opção selecionável.</span>
                                        </v-select>
                                        <small v-if="errors[0]" class="text-danger">
                                             Este campo é de preenchimento obrigatório.
                                        </small>
                                        <small v-if="form.errors.type" class="text-danger">
                                            {{ form.errors.type }}
                                        </small>
                                    </b-form-group>
                                </validation-provider>
                            </b-col>
                            <b-col lg="4" sm="12">
                                <validation-provider
                                    #default="{ errors }"
                                    name="Codigo"
                                    rules="required"
                                >
                                <b-form-group label="Código*" label-for="code">
                                    <b-form-input
                                        :state="errors.length > 0 || form.errors.code ? false:null"
                                        id="code"
                                        v-mask="'#####'"
                                        autocomplete="off"
                                        v-model="form.code"
                                        placeholder="0000"
                                    />
                                    <small v-if="errors[0]" class="text-danger">
                                            Este campo é de preenchimento obrigatório.
                                    </small>
                                    <small v-if="form.errors.code" class="text-danger">
                                        {{ form.errors.code }}
                                    </small>
                                    <span class="infoInput">Informe o código referente a este ponto de atendimento.</span>
                                </b-form-group>
                            </validation-provider>
                            </b-col>
                        </b-row>
                        <b-row class="mb-1">
                            <b-col lg="4" sm="12" class="pr-lg-0">
                                <b-form-group label="CEP*" label-for="cep">
                                    <validation-provider
                                        #default="{ errors }"
                                        name="cep"
                                        rules="required"
                                    >
                                        <b-form-input
                                            :state="errors.length > 0 || form.errors.cep ? false:null"
                                            id="cep"
                                            v-mask="'#####-###'"
                                            autocomplete="off"
                                            @update="searchCep"
                                            v-model="form.cep"
                                            placeholder="00000-000"
                                        />
                                        <small v-if="errors[0]" class="text-danger">
                                            Este campo é de preenchimento obrigatório.
                                        </small>
                                        <small v-if="form.errors.cep" class="text-danger">
                                            {{ form.errors.cep }}
                                        </small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                            <b-col lg="4" sm="12" class="pr-lg-0">
                                <b-form-group label="Rua/Avenida*" label-for="address">
                                    <validation-provider
                                        #default="{ errors }"
                                        name="address"
                                        rules="required"
                                    >
                                        <b-form-input
                                            :state="errors.length > 0 || form.errors.address ? false:null"
                                            id="address"
                                            v-mask="('X'.repeat(250))"
                                            autocomplete="off"
                                            v-model="form.address"
                                            placeholder="Ex: Admar Gonzaga"
                                        />
                                        <small v-if="errors[0]" class="text-danger">
                                            Este campo é de preenchimento obrigatório.
                                        </small>
                                        <small v-if="form.errors.address" class="text-danger">
                                            {{ form.errors.address }}
                                        </small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                            <b-col lg="4" sm="12">
                                <b-form-group label="Número*" label-for="number">
                                    <validation-provider
                                        #default="{ errors }"
                                        name="number"
                                        rules="required"
                                    >
                                        <b-form-input
                                            :state="errors.length > 0 || form.errors.number ? false:null"
                                            id="number"
                                            v-mask="('X'.repeat(15))"
                                            autocomplete="off"
                                            v-model="form.number"
                                            placeholder="Ex: 54"
                                        />
                                        <small v-if="errors[0]" class="text-danger">
                                            Este campo é de preenchimento obrigatório.
                                        </small>
                                        <small v-if="form.errors.number" class="text-danger">
                                            {{ form.errors.number }}
                                        </small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row class="mb-1">
                            <b-col lg="4" sm="12" class="pr-lg-0">
                                <b-form-group label="Complemento" label-for="complement">
                                    <b-form-input
                                        :state="form.errors.complement ? false:null"
                                        id="complement"
                                        autocomplete="off"
                                        v-model="form.complement"
                                        placeholder="EX: Bloco B, 2ª andar, sala 201"
                                    />
                                    <small v-if="form.errors.complement" class="text-danger">
                                        {{ form.errors.complement }}
                                    </small>
                                </b-form-group>
                            </b-col>
                            <b-col lg="4" sm="12" class="pr-lg-0">
                                <b-form-group label="Bairro*" label-for="neighborhood">
                                    <validation-provider
                                        #default="{ errors }"
                                        name="neighborhood"
                                        rules="required"
                                    >
                                        <b-form-input
                                            :state="errors.length > 0 || form.errors.neighborhood ? false:null"
                                            id="neighborhood"
                                            autocomplete="off"
                                            v-model="form.neighborhood"
                                            placeholder="Ex: Sede/SC"
                                        />
                                        <small v-if="errors[0]" class="text-danger">
                                            Este campo é de preenchimento obrigatório.
                                        </small>
                                        <small v-if="form.errors.neighborhood" class="text-danger">
                                            {{ form.errors.neighborhood }}
                                        </small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                            <b-col lg="4" sm="12">
                                <validation-provider #default="{ errors }" name="city" rules="required">
                                    <b-form-group
                                        label="Cidade*"
                                        label-for="city"
                                        :state="errors.length > 0 || form.errors.city ? false:null">
                                        <v-select
                                            id="city"
                                            :reduce="(option => option.id_cidade)"
                                            v-model="form.city"
                                            :options="cities"
                                            label="nome"
                                            placeholder="Selecione uma cidade"
                                        >
                                            <span slot="no-options">Nenhuma opção selecionável.</span>
                                        </v-select>
                                        <small v-if="errors[0]" class="text-danger">
                                            Este campo é de preenchimento obrigatório.
                                        </small>
                                        <small v-if="form.errors.city" class="text-danger">
                                            {{ form.errors.city }}
                                        </small>
                                    </b-form-group>
                                </validation-provider>
                            </b-col>
                        </b-row>
                        <UnidadeField
                            :error="form.errors.operatingUnit"
                            @selected="fillUnidade"
                            :preSelected="form.operatingUnit"
                        />
                    </b-form>
                </validation-observer>
            </section>
            <section class="buttons mt-3">
                <b-row>
                    <b-button id="save-ponto-atendimento"
                        class="mr-2 mb-1"
                        variant="custom-blue"
                        @click.prevent="validationForm(true)"
                        :disabled="saving || savingAndNew"
                    >
                        <feather-icon icon="CheckIcon" class="mr-50"/>
                        <span class="align-middle">Salvar ponto de atendimento</span>
                        <span v-if="saving" class="spinner-border spinner-border-sm ml-1" role="status" aria-hidden="true"></span>
                    </b-button>
                    <b-button id="save-and-other-ponto-atendimento"
                        class="mr-2 mb-1"
                        variant="custom-blue"
                        @click.prevent="validationForm(false)"
                        :disabled="saving || savingAndNew"
                    >
                        <feather-icon icon="CheckIcon" class="mr-50"/>
                        <span class="align-middle">Salvar e cadastrar um novo</span>
                        <span v-if="savingAndNew" class="spinner-border spinner-border-sm ml-1" role="status" aria-hidden="true"></span>
                    </b-button>
                    <b-button id="cancel-register-ponto-atendimento"
                        class="mb-1"
                        :disabled="saving || savingAndNew"
                        variant="outline-danger"
                        @click.prevent="openModalConfirm"
                    >
                        <feather-icon icon="XIcon" class="mr-50"/>
                        <span class="align-middle">Cancelar</span>
                    </b-button>
                </b-row>
            </section>
        </main>
    </div>
</template>

<script>
import { BRow, BCol, BForm, BFormGroup, BFormInput, BButton } from 'bootstrap-vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'

import PageHeader from '@/views/components/custom/page-header/PageHeader.vue';
import UnidadeField from '@/views/components/custom/field-select-unidade-ponto-atendimento/UnidadeField.vue';
import ConfirmModal from '@/views/components/custom/modals/ConfirmModal.vue';
import SucessoModal from '@/views/components/custom/modals/SucessoCriacaoEdicaoModal.vue';
import TimedAlert from '@/views/components/custom/timed-alert/TimedAlert.vue';
import vSelect from 'vue-select';
import handleErrorsService from './Services/HandleErrors';
import { getUserData } from "@/auth/utils";

export default {
    title: 'Cadastrar ponto de atendimento',

    components: {
        PageHeader, BRow, BCol, BForm, BFormGroup, BButton,
        BFormInput, ValidationProvider, ValidationObserver, vSelect,
        UnidadeField, ConfirmModal, SucessoModal, TimedAlert
    },

    data() {
        return {
             userData: getUserData(),
             linkItems: [
                {
                    name: 'Pontos de Atendimento',
                    routeName: 'ponto-atendimento-list'
                },
                {
                    name: 'Cadastrar novo',
                    active: true
                }
            ],
            required,
            saving: false,
            savingAndNew: false,
            savedAlert: false,
            form: {
                name: null,
                type: null,
                code: null,
                cep: null,
                address: null,
                number: null,
                complement: null,
                neighborhood: null,
                city: null,
                operatingUnit: null,
                region: null,
                errors: {
                    name: null,
                    type: null,
                    code: null,
                    cep: null,
                    address: null,
                    number: null,
                    complement: null,
                    neighborhood: null,
                    city: null,
                    operatingUnit: null,
                }
            },
            modal: {
                showModal: false,
                typeModal: 'danger'
            },
            modalSuccess: {
                showModal: false,
                typeModal: 'success',
                caseModal: 'criacao'
            },
            servicePointType: [],
            cities: []
        }
    },

    mounted () {
        this.loadServicePointType();
        this.loadCities();
    },

    methods: {
        validationForm(redirectToList) {
            this.$refs.pontoAtendimentoRules.validate().then(success => {
                if (success && !this.form.errors.cep) {
                    redirectToList ? this.saving = true : this.savingAndNew = true;
                    this.savePontoAtendimento(redirectToList);
                }
            })
        },

        savePontoAtendimento(redirectToList) {
            const parameters = {
                descricao: this.form.name,
                id_tipo_ponto_atendimento: this.form.type,
                codigo: this.form.code,
                cep: this.form.cep.replace('-', ''),
                endereco: this.form.address,
                numero: this.form.number,
                complemento: this.form.complement,
                bairro: this.form.neighborhood,
                id_cidade: this.form.city,
                id_unidade: this.form.operatingUnit
            };

            this.$http.post(this.$api.listOrSavePontoAtendimento(), parameters).then(() => {
                this.saving = false;
                this.savingAndNew = false;
                this.cleanForm();

                if(redirectToList) {
                    this.openSuccessModal();
                    return;
                }

                this.savedAlert = !this.savedAlert;
            }).catch(({ response: { data } }) => {
                handleErrorsService.handleErrosPontoAtendimento(data, this.form.errors);

                this.saving = false;
                this.savingAndNew = false;
            })
        },

        cleanForm() {
            this.form.name = null;
            this.form.type = null;
            this.form.code = null;
            this.form.cep = null;
            this.form.address = null;
            this.form.number = null;
            this.form.complement = null;
            this.form.neighborhood = null;
            this.form.city = null;
            this.form.operatingUnit = null;

            this.form.errors.name = null;
            this.form.errors.type = null;
            this.form.errors.code = null;
            this.form.errors.cep = null;
            this.form.errors.address = null;
            this.form.errors.number = null;
            this.form.errors.complement = null;
            this.form.errors.neighborhood = null;
            this.form.errors.city = null;
            this.form.errors.operatingUnit = null;

            this.$refs.pontoAtendimentoRules.reset();
        },

        redirectToList() {
            this.$router.push({ name: 'ponto-atendimento-list' });
        },

        loadServicePointType() {
            this.$http.get(this.$api.getServicePointTypes()).then(({ data }) => {
                this.servicePointType = data;
            });
        },

        loadCities() {
            this.$http.get(this.$api.getCidadesDoEstado(this.userData.departamento.uf)).then(({ data }) => {
                this.cities = data.cidades;
            })
        },

        fillUnidade(event) {
            this.form.operatingUnit = event;
        },

        searchCep(cepMasked) {
            this.form.errors.cep = null;

            const cep = cepMasked.replace('-', '');

            if(cep.length == 8) {
                this.$cep.searchCep(
                    cep, this.form,
                    this.form.errors, this.cities
                );
            }
        },

        cancelRegister() {
            this.$router.push({ name: 'ponto-atendimento-list' });
        },

        openModalConfirm() {
            this.modal.showModal = true;
        },

        openSuccessModal() {
            this.modalSuccess.showModal = true;
        },

        closeModalConfirm() {
            this.modal.showModal = false;
        }
    }
}
</script>

<style>
.infoInput {
    font-size: 0.9rem;
    color: #B9B9C3;
    display: block;
}
</style>
